
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class BackToTop extends Vue {
  public visible = false;

  public mounted(): void {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }
  public beforeDestroy(): void {
    window.removeEventListener("scroll", this.onScroll);
  }
  public onScroll(): void {
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    this.visible = y > 300;
  }
  public toTop(): void {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
